module.exports = __webpack_public_path__ + "static/media/2x1-203dpi.3815966a.png";